import type React from 'react';

import { ButtonGroup, FormField, Label } from '@zillow/constellation-10';

type Props = {
  children: React.ReactNode;
};

export default function SmokingButtonGroup({ children }: Props) {
  return (
    <FormField
      required
      label={<Label>Is smoking allowed on the property?</Label>}
      control={
        <ButtonGroup orientation="vertical" conjoined aria-label="smoking location" css={{ width: '100%' }}>
          {children}
        </ButtonGroup>
      }
    />
  );
}
